import { ReactComponent as ResetIcon } from "../../img/butter_svgs/Reset.svg";
import { INITIAL_STATE, resetOrderState, GlobalStore } from "../../store/global/GlobalStore";

import React, { useCallback } from "react";
import { resetApprovalState } from "../../store/approvals/ApprovalsStore";

export const ResetButton: React.FC = () => {
  const theme = GlobalStore.useState(s => s.theme);
  const { makerTokens, takerTokens } = GlobalStore.useState(s => {
    return {
      makerTokens: s.makerTokens,
      takerTokens: s.takerTokens,
    };
  });

  const isResetApplicable = useCallback(() => {
    if (takerTokens.length !== INITIAL_STATE.takerTokens.length || makerTokens.length > 0) {
      return true;
    }
  }, [makerTokens.length, takerTokens]);

  return isResetApplicable() ? (
    <ResetIcon
      style={{ cursor: "pointer", color: theme.button.primary.surface.active }}
      onClick={() => resetOrderAndApprovalState()}
    />
  ) : null;
};

// Helper functions
export const resetOrderAndApprovalState = () => {
  resetOrderState();
  resetApprovalState();
};
